import React from 'react';
import { withTheme } from 'styled-components';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Box, Text, Button } from '@rsos/components/capstone/base';
import { ModalHeader, ModalBody } from '../../../base/Modal/ModalComponents';

const ModalError = ({ onClick, onClose, theme, error }) => {
  return (
    <>
      <ModalHeader onClose={onClose}>
        <Box horizontal flow={10} align="center" justify="center">
          <AttentionTriangleIcon
            height={13}
            width={14}
            color={theme.colors.lightDanger}
          />
          <Text size="normal" color="lightDanger">
            {error ? error : 'There was an error'}
          </Text>
        </Box>
      </ModalHeader>
      <ModalBody justify="center" noFooter>
        <Box horizontal justify="space-between">
          <Button
            type="button"
            onClick={onClose}
            btnType="tertiary"
            size="small"
            grow
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={onClick}
            btnType="secondary"
            size="small"
            grow
          >
            Try Again
          </Button>
        </Box>
      </ModalBody>
    </>
  );
};

export default withTheme(ModalError);
